import { render, staticRenderFns } from "./AllRouteChannelUpdate.vue?vue&type=template&id=2653cef8&"
import script from "./AllRouteChannelUpdate.vue?vue&type=script&lang=js&"
export * from "./AllRouteChannelUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports